<template>
  <div class="uk-grid-small uk-child-width-auto uk-grid">
    <label :class="{ 'uk-form-danger': error }">
      <input
        class="uk-checkbox"
        type="checkbox"
        :name="name"
        :checked="value"
        v-validate="{'required': shouldValidate}"
        @change="$emit('input', $event.target.checked)"
      />
      <span v-html="$t(label)" :class="{ 'uk-text-small': textSmall }"></span>
    </label>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  inheritAttrs: false,
  props: {
    label: {
      required: true,
      Type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      Type: String
    },
    shouldValidate:{},
    error: {
      type: String,
      default: null
    },
    textSmall: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
